<template>
  <div>
    <div class="topHeader app">
      <img src="/static/img/index/back.png" alt="" class="backImg" @click="goBack()" />
      <div class="title">
        {{$t('addBank.addBankText')}}
        <!-- 添加银行卡 -->
      </div>
    </div>
    <div class="bankInfo">
      <div class="list">
        <div class="name">
          <!-- 卡号 -->
          {{$t('addBank.cardNum')}}
        </div>
        <div class="value">
          <input type="text" :placeholder="$t('addBank.careNumPlcae')" v-model="bankCard" @input="no_change">
        </div>
        <div class="deleteView" v-if="bankCard" @click="deleteBankCard">
          <img src="/static/img/payment/delete.png" alt="">
        </div>
      </div>
      <div class="list">
        <div class="name">
          {{$t('addBank.caredName')}}
          <!-- 姓名 -->
        </div>
        <div class="value">
          <input type="text" :placeholder="$t('addBank.cardNamePlace')" v-model="name" :readonly="readonly1">
        </div>
        <div class="deleteView" v-if="name && !readonly1" @click="deleteName">
          <img src="/static/img/payment/delete.png" alt="">
        </div>
      </div>
      <div class="list">
        <div class="name">
          {{$t('addBank.IDName')}}
          <!-- 身份证号  -->
        </div>
        <div class="value">
          <input type="text" :placeholder="$t('addBank.IDNamePlace')" v-model="IDCard" :readonly="readonly">
        </div>
        <div class="deleteView" v-if="IDCard && !readonly" @click="deleteIDCard">
          <img src="/static/img/payment/delete.png" alt="">
        </div>
      </div>
      <div class="list">
        <div class="name">
          {{$t('addBank.phone')}}
          <!-- 手机号 -->
        </div>
        <div class="value">
          <input type="number" :placeholder="$t('addBank.phonePlcae')" v-model="phone">
        </div>
        <div class="deleteView" v-if="phone" @click="deletePhone">
          <img src="/static/img/payment/delete.png" alt="">
        </div>
      </div>
      <div class="list" v-if="false">
        <!-- 获取验证码，此列隐藏 -->
        <div class="name">
          {{$t('addBank.code')}}
          <!-- 验证码 -->
        </div>
        <div class="value">
          <input type="number" :placeholder="$t('addBank.codePlcae')" v-model="verifycode">
        </div>

        <div class="getCode" v-show="show" @click="getCode">
          {{$t('addBank.getCode')}}
          <!-- 获取验证码 -->
        </div>
        <div class="getCode" v-show="!show">{{count}}s</div>
      </div>

    </div>
    <!-- <div class="error_tips" v-show="showError">
      <img src="/static/img/payment/errorIcon.png" alt="">
      <span>{{textError}}</span>
    </div> -->
    <div class="btn" v-if="!isComplate">下一步</div>
    <div class="btn1" v-else @click="getCode">下一步</div>



    <div class="argeementDiv" @click.stop="agreeAgreement()">
      <img src="/static/img/payment/select-off.png" alt="" v-if="!isArgementCheck">
      <img src="/static/img/payment/select-check.png" alt="" v-else>
      {{$t('addBank.agree')}}<span @click.stop="toagreeAgreement()">{{$t('addBank.payAgreement')}}</span>
    </div>

    <!-- 输入密码框 -->
    <div class="setPassAlertMask" v-if="isShowPassWordAlert">
      <div class="passwordModel">
        <div class="close" @click="passClose"></div>
        <p class="pass-title">输入验证码</p>
        <div class="captcha">
          <input v-for="(c, index) in ct" :key="index" type="number" v-model.number="ct[index]" ref="input"
            :style="{borderBottomColor: index <= cIndex ? '#333' : ''}" @input="e => {onInput(e.target.value, index)}"
            @keydown.delete="e=>{onKeydown(e.target.value, index)}" @focus="onFocus" :disabled="loading">
        </div>
        <div class="modelBtn" v-if="!isComplate2">
          {{$route.query.redirect&&$route.query.redirect.indexOf('bankManage')!=-1 ? $t('addBank.addBankText'): $t('addBank.openPay')}}
        </div>
        <div class="modelBtn1" v-else @click="sendCaptcha">
          {{$route.query.redirect&&$route.query.redirect.indexOf('bankManage')!=-1 ?$t('addBank.addBankText'): $t('addBank.openPay')}}
        </div>
      </div>
    </div>


  </div>
</template>
<script>
  export default {
    data() {
      return {
        bankCard: "", //银行卡号
        name: "", //姓名
        IDCard: "", //身份证号
        phone: "",
        count: "",
        show: true,
        timer: null,
        showError: false,
        textError: "",
        isComplate: false,
        verifycode: "", //短信验证码
        isArgementCheck: false, //是否勾选协议
        requestNo: "", //预绑卡关联号
        code_data: "",
        bankCardTrim: "",
        readonly: false,
        readonly1: false,
        ct: ['', '', '', '', '', ''],
        isShowPassWordAlert: false,
        isComplate2: false,
        loading: false,
      }
    },
    computed: {
      ctSize() {
        return this.ct.length;
      },
      cIndex() {
        let i = this.ct.findIndex(item => item === '');
        i = (i + this.ctSize) % this.ctSize;
        return i;
      },
      lastCode() {
        return this.ct[this.ctSize - 1];
      }
    },
    watch: {
      bankCard() {
        if (this.bankCard && this.name && this.IDCard && (this.phone && /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this
            .phone)) && this.isArgementCheck) {
          this.isComplate = true
        } else {
          this.isComplate = false
        }
      },
      name() {
        if (this.bankCard && this.name && this.IDCard && (this.phone && /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this
            .phone)) && this.isArgementCheck) {
          this.isComplate = true
        } else {
          this.isComplate = false
        }
      },
      phone() {
        if (this.bankCard && this.name && this.IDCard && (this.phone && /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this
            .phone)) && this.isArgementCheck) {
          this.isComplate = true
        } else {
          this.isComplate = false
        }
      },
      IDCard() {
        if (this.bankCard && this.name && this.IDCard && (this.phone && /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this
            .phone)) && this.isArgementCheck) {
          this.isComplate = true
        } else {
          this.isComplate = false
        }
      },
      // verifycode() {
      //   if (this.bankCard && this.name && this.IDCard && (this.phone&& /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.phone))  && this.isArgementCheck) {
      //     this.isComplate = true
      //   } else {
      //     this.isComplate = false
      //   }
      // },
      isArgementCheck() {
        if (this.bankCard && this.name && this.IDCard && (this.phone && /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this
            .phone)) && this.isArgementCheck) {
          this.isComplate = true
        } else {
          this.isComplate = false
        }
      },
      cIndex() {
        this.resetCaret();
      },
      lastCode(val) {
        console.log(val, 'this.ctSize', this.ctSize)
        if (val) {
          this.$refs.input[this.ctSize - 1].blur();
          this.isComplate2 = true;
        } else {
          this.isComplate2 = false;
        }
      },
    },
    methods: {
      // 开通并支付
      sendCaptcha() {
        this.openAndPay();
      },
      reset() {
        // 重置。一般是验证码错误时触发。
        this.ct = this.ct.map(item => '');
        this.resetCaret();
        this.loading = false;
      },
      onInput(val, index) {
        this.msg = ''
        val = val.replace(/\s/g, '');
        console.log(val)
        if (index == this.ctSize - 1) {
          this.ct[this.ctSize - 1] = val[0]; // 最后一个码，只允许输入一个字符。
        } else if (val.length > 1) {
          let i = index;
          for (i = index; i < this.ctSize && i - index < val.length; i++) {
            this.ct[i] = val[i];
          }
          this.resetCaret();
        }
      },
      // 重置光标位置。
      resetCaret() {
        this.$refs.input[this.ctSize - 1].focus();
      },
      onFocus() {
        // 监听 focus 事件，将光标重定位到“第一个空白符的位置”。
        let index = this.ct.findIndex(item => item === '');
        index = (index + this.ctSize) % this.ctSize;
        // console.log(this.$refs.input)
        this.$refs.input[index].focus();
      },
      onKeydown(val, index) {
        if (val === '') {
          // 删除上一个input里的值，并对其focus。
          if (index > 0) {
            this.ct[index - 1] = '';
            this.$refs.input[index - 1].focus();
          }
        }
      },
      passClose() {
        this.isShowPassWordAlert = false;
      },
      toagreeAgreement() {
        var BNAKOBJ = {
          bankCard: this.bankCardTrim || '',
          name: this.name || '',
          IDCard: this.IDCard || '',
          phone: this.phone || '',
        }
        sessionStorage.setItem('BNAKOBJ', JSON.stringify(BNAKOBJ));
        this.$router.push({
          path: "/appBankAgreement"
        })
      },
      no_change(e) {
        var $this = e.target; // 获取dom
        // 正则匹配：大小字母加数字-每四个字符加空格-删除最后一位空格（用于展示）
        this.bankCard = $this.value
          .replace(/[^0-9A-Za-z]/g, "")
          .replace(/(.{4})/g, "$1 ")
          .replace(/ $/g, "")
          .toUpperCase()
        var data = this.bankCard.replace(/ /g, ""); // 匹配去掉所有空格（用于提交）
        this.bankCardTrim = data;

      },
      deleteBankCard() {
        this.bankCard = ""
        this.bankCardTrim = ""
      },
      deleteName() {
        this.name = ""
      },
      deleteIDCard() {
        this.IDCard = ""
      },
      deletePhone() {
        this.phone = ""
      },
      goBack() {
        console.log(this.$route)
        if (this.$route.query.redirect) {
          this.$router.push({
            path: this.$route.query.redirect
          })
        } else {
          this.$router.go(-1);
        }
      },
      //个人实名认证信息（登录）
      cardinfo() {
        let that = this;
        that.$fetchql.Post("bf/cardinfo").then((res) => {
          if (res.code == 0) {
            if (res.data.idcard) {
              that.IDCard = res.data.idcard
              that.readonly = true;
            }
            if (res.data.realname) {
              that.name = res.data.realname
              that.readonly1 = true;
            }
          }
        })
      },
      //获取验证码
      getCode() {
        let that = this;
        if (!that.bankCard) {
          that.$toast({
            message: that.$i18nn.t('addBank.IncardNum')
          });
          // that.showError = true
          // that.textError = "请输入银行卡号"
          return false;
        }
        if (!that.name) {
          // that.showError = true
          // that.textError = "请输入开卡姓名"
          that.$toast({
            message: that.$i18nn.t('addBank.InCardName'),
          });
          return false;
        }
        if (!that.IDCard) {
          that.$toast({
            message: that.$i18nn.t('addBank.InCardIdNum'),
          });
          // that.showError = true
          // that.textError = "请输入银行预留身份证号"
          return false;
        }
        if (!that.phone) {
          that.$toast({
            message: that.$i18nn.t('addBank.InCardPhone'),
          });
          // that.showError = true
          // that.textError = "请输入银行预留手机号"
          return false;
        }

        if (!this.isArgementCheck) {
          // "请阅读并勾选银联用户相关服务协议",
          that.$toast({
            message: that.$i18nn.t('addBank.pleaseReadAggrement')
          });
          return
        }

        if (that.$store.state.token) {
          that.$loading.show();
          that.$fetchql.Post("bankcard/bind", {
            cardno: that.bankCardTrim,
            bankmobile: that.phone,
            cardname: that.name,
            idcard: that.IDCard
          }, "noMsg").then((res) => {
            console.log(res);
            that.$loading.hide();
            if (res.code == 0) {
              // that.showError = false
              // that.textError = ''
              console.log(res.data.requestNo)
              if (res.data && res.data.requestNo) {
                that.requestNo = res.data.requestNo
                this.isShowPassWordAlert = true;
              } else {
                that.$toast({
                  message: '系统异常，请稍后再试！',
                });
              }

              const TIME_COUNT = 60;
              if (!that.timer) {
                that.count = TIME_COUNT;
                that.show = false;
                that.timer = setInterval(() => {
                  if (that.count > 0 && that.count <= TIME_COUNT) {
                    that.count--;
                  } else {
                    that.show = true;
                    clearInterval(that.timer);
                    that.timer = null;
                  }
                }, 1000);
              }
            } else {
              // that.showError = true
              // that.textError = res.msg
              that.$toast({
                message: res.msg,
              });
            }
          });
        } else {
          this.$router.push({
            path: "/login",
            query: {
              redirect: this.$route.fullPath,
            },
          });
        }
      },
      //确认绑卡接口
      bindidcard() {
        let that = this;
        // that.showError = false
        // that.textError = ""
        if (!that.ct.join('')) return;
        if (that.$store.state.token) {
          that.$loading.show();
          that.$fetchql.Post("bankcard/bind/confirm", {
            requestno: that.requestNo,
            verifycode: that.ct.join(''),
          }).then((res) => {
            console.log(res);
            that.$loading.hide();
            if (res.code == 0) {
              var BNAKOBJ = {
                bankCard: '',
                name: '',
                IDCard: '',
                phone: '',
              }
              sessionStorage.setItem('BNAKOBJ', JSON.stringify(BNAKOBJ));
              // that.showError = false
              // that.textError = ''
              let data = {
                source: "appPayment",
                type: that.$route.query.type || that.$route.query.redirect.type,
                orderno: that.$route.query.orderno,
                id: that.$route.query.id,
                status: that.$route.query.status,
              }

              if (res.data && res.data.url) {
                //res.data.url = 设置支付密码的url

                //如果是银行卡管理过来，设置完支付密码返回到银行卡管理页面
                if (that.$route.query.redirect && that.$route.query.redirect.indexOf("bankManage") != -1) {
                  window.location.href = res.data.url + "?Address=" +
                    location.origin + "/bankManage"
                } else {
                  var callUrl = that.$route.query.redirect.split('/appBankList?')
                  var list1 = callUrl[1].split('&')
                  var obj = {}
                  list1.forEach(item => {
                    obj[item.split('=')[0]] = item.split('=')[1]
                  })
                  //如果是支付中的银行卡列表过来，设置完支付密码返回到支付中的银行卡列表
                  window.location.href = res.data.url + "?Address=" +
                    location.origin + "/appBankList?backstring=" +
                    JSON
                    .stringify(obj)
                }
              } else if (res.data && !res.data.url) {
                this.$toast({
                  message: '添加成功',
                });
                // 友盟埋点，click事件
                window._czc && window._czc.push(["_trackEvent", 'Add_BankCard_Success', '添加成功', '添加成功', '1', Date
                  .now()
                ])

                if (this.$route.query.redirect) {
                  that.$router.push({
                    path: this.$route.query.redirect
                  })
                } else {
                  this.$router.go(-1)
                }
              } else {
                this.$toast({
                  message: '添加成功',
                });
                // 友盟埋点，click事件
                window._czc && window._czc.push(["_trackEvent", 'Add_BankCard_Success', '添加成功', '添加成功', '1', Date
                  .now()
                ])
                if (this.$route.query.redirect) {
                  that.$router.push({
                    path: this.$route.query.redirect
                  })
                } else {
                  this.$router.go(-1)
                }
              }
            }
          });
        } else {
          that.$router.push({
            path: "/login",
            query: {
              redirect: that.$route.fullPath,
            },
          });
        }
      },
      //开通并支付
      openAndPay() {
        let that = this;
        that.bindidcard()

      },
      //点击协议按钮
      agreeAgreement() {
        this.isArgementCheck = !this.isArgementCheck
      }
    },
    mounted() {
      let that = this;

      if (that.$store.state.token) {
        that.cardinfo()
      } else {
        that.$router.push({
          path: "/login",
          query: {
            redirect: that.$route.fullPath,
          },
        });
      }

      var BNAKOBJ;
      if (sessionStorage.getItem('BNAKOBJ')) {
        BNAKOBJ = JSON.parse(sessionStorage.getItem('BNAKOBJ'))
        this.bankCard = BNAKOBJ.bankCard;
        this.bankCardTrim = BNAKOBJ.bankCard;
        this.name = BNAKOBJ.name;
        this.IDCard = BNAKOBJ.IDCard;
        this.phone = BNAKOBJ.phone;
      }

    }

  }

</script>
<style scoped lang="less">
  .setPassAlertMask {
    position: fixed;
    z-index: 2;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.85);

    .passwordModel {
      overflow: hidden;
      position: absolute;
      left: 50%;
      top: 50%;
      width: 281px;
      height: 195px;
      background: #333333;
      margin-left: -140.5px;
      margin-top: -97.5px;
      border-radius: 4px;
      text-align: center;

      .close {
        position: absolute;
        right: 12px;
        top: 13px;
        width: 26px;
        height: 26px;
        background: url('/static/img/give/close.png');
        background-size: 26px 26px;
      }

      p {
        margin: 0;
      }

      .pass-title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        margin: 20px auto 25px;
      }

      .captcha {
        display: flex;
        justify-content: center;

        input {
          margin-right: 9px;
          width: 33px;
          height: 33px;
          text-align: center;
          border: none;
          outline: none;
          box-sizing: border-box;
          background: #383838;
          border-radius: 3px;
          color: #fff;
          font-size: 16px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
        }

        input:last-of-type {
          margin-right: 0;
        }

        input:disabled {
          // color: #000;
          // background-color: #fff;
        }
      }

      .modelBtn {
        width: 243px;
        height: 40px;
        background: url(/static/img/payment/modelBtn.png);
        background-size: 243px 40px;
        font-size: 13px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: bold;
        color: #282828;
        line-height: 40px;
        margin: 30px auto;
        text-align: center;
      }

      .modelBtn1 {
        width: 243px;
        height: 40px;
        background: url(/static/img/payment/modelBtn1.png);
        background-size: 243px 40px;
        font-size: 13px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: bold;
        color: #282828;
        line-height: 40px;
        margin: 30px auto;
        text-align: center;
      }
    }
  }

  .topHeader {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 9;
    height: 94px;
    background: #000;

    .backImg {
      width: 21px;
      height: 9px;
      display: inline-block;
      vertical-align: middle;
      position: absolute;
      left: 15px;
      top: 59px;
    }

    .title {
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      display: inline-block;
      width: 100%;
      margin-top: 56px;
    }

  }

  .bankInfo {
    margin-top: 90px;
    padding-left: 25px;
    // margin-left: 25px;
    // margin-right: 25px;
    padding-right: 25px;
    // background: #141817;
    // border-radius: 4px;

    .list {
      display: flex;
      align-items: center;
      padding-left: 3px;
      padding-right: 3px;
      border-bottom: 1px solid #282828;
      height: 61px;

      .name {
        color: #BDBDBD;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        width: 75px
      }

      .value {
        flex: 1;

        input {
          // padding-left: 52px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          color: #FFFFFF;
          background: none;
          outline: none;
          border: none;
          width: 100%;
          opacity: 1
        }


        input::-webkit-input-placeholder {
          color: #bdbdbd;
          font-size: 14px !important;
          opacity: 0.5;
        }

        input:-moz-placeholder {
          color: #bdbdbd;
          font-size: 14px !important;
          opacity: 0.5;
        }

        input::-moz-placeholder {
          color: #bdbdbd;
          font-size: 14px !important;
          opacity: 0.5;
        }

        input:-ms-input-placeholder {
          color: #bdbdbd;
          font-size: 14px !important;
          opacity: 0.5;
        }
      }

      .getCode {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #1CE89E;
      }

      .deleteView {
        img {
          width: 16px;
          height: 16px;
        }
      }
    }

    .list:last-child {
      // border-bottom: none;
    }
  }

  .btn {
    width: 325px;
    background: url(/static/img/payment/btn-off2.png);
    background-size: 325px 45px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: bold;
    color: #282828;
    line-height: 45px;
    height: 45px;
    letter-spacing: 1px;
    margin: 30px 25px 15px;
    text-align: center;
  }

  .btn1 {
    width: 325px;
    background: url(/static/img/payment/btn-on2.png);
    background-size: 325px 45px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: bold;
    color: #282828;
    line-height: 45px;
    height: 45px;
    letter-spacing: 1px;
    margin: 30px 25px 15px;
    text-align: center;
  }

  .argeementDiv {
    padding-left: 25px;

    img {
      width: 16px;
      height: 16px;
      vertical-align: middle;
      margin-right: 10px;
      margin-bottom: 3px;
    }

    font-size: 13px;
    font-family: PingFangSC-Regular,
    PingFang SC;
    color: #8D8F9F;

    span {
      color: #4BCFAF;
    }

    a {
      color: #4BCFAF;
      text-decoration: none;
    }
  }

  .error_tips {
    padding-left: 15px;
    padding-top: 16px;

    img {
      width: 14px;
      height: 14px;
      vertical-align: middle;
      margin-right: 6px;
      margin-bottom: 3px;
    }

    span {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #BDBDBD;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/appModel/addBank.vue